import * as tasks from './minigames/xml/ug_p21ext';

function transObjToArray(){
    let result = [];
    for(let task in tasks){
        result.push(tasks[task]);
    }
    return result;
}

export default transObjToArray();